import React, { createContext, useState, useContext } from "react";

// Import your translation files
import translationEN from "../../locales/en.json";
import translationFR from "../../locales/ar.json";
// Add more translations as needed

const translations = {
  en: translationEN,
  ar: translationFR,
  // Add more locales and their translations as needed
};

const LocalizationContext = createContext();

const LocalizationProvider = ({ children }) => {
  const [locale, setLocale] = useState(
    localStorage.getItem("lang") ? localStorage.getItem("lang") : "en"
  ); // Default locale is set to English ('en')

  const t = (key) => {
    return translations[locale][key] || key; // Use the translated value or the key itself if not found
  };

  return (
    <LocalizationContext.Provider value={{ locale, setLocale, t }}>
      {children}
    </LocalizationContext.Provider>
  );
};

const useLocalization = () => {
  return useContext(LocalizationContext);
};

export { LocalizationProvider, useLocalization };
